/** @format */
import { RefObject, useEffect, useRef } from 'react';

/**
 * @deprecated use Feather/hooks/use-click-outside instead
 */
export const useClickOutside = (
    refs: RefObject<HTMLElement> | RefObject<HTMLElement>[],
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Legacy code: do not use as an example.
    handler: (event: any) => void
) => {
    const refsArray = useRef<RefObject<HTMLElement>[]>([]);
    // eslint-disable-next-line @typescript-eslint/no-empty-function -- Legacy code: do not use as an example.
    const callback = useRef<(event: MouseEvent | TouchEvent) => void>(() => {});

    refsArray.current = Array.isArray(refs) ? refs : [refs];
    callback.current = handler;

    function isClickInside(
        refs: RefObject<HTMLElement>[],
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Legacy code: do not use as an example.
        event: any
    ): boolean {
        return refs.some((ref: RefObject<HTMLElement>) => {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access -- Legacy code: do not use as an example.
            return !ref.current || ref.current.contains(event.target);
        });
    }

    useEffect(() => {
        const listener = (event: MouseEvent | TouchEvent) => {
            // Do nothing if clicking ref's element or descendent elements
            if (isClickInside(refsArray.current, event)) {
                return;
            }
            callback.current(event);
        };

        document.addEventListener('mousedown', listener);
        document.addEventListener('touchstart', listener);

        return () => {
            document.removeEventListener('mousedown', listener);
            document.removeEventListener('touchstart', listener);
        };
    }, []);
};
